import { parsePhoneNumberFromString } from 'libphonenumber-js';
import isNil from 'lodash/isNil';
import { SegmentedMessage } from 'sms-segments-calculator';

import { countOccurrences } from './strings';

export const TWILIO_MAX_LENGTH_FOR_BODY = 1600;
export const SMS_MAX_LENGTH = 160;

const NEW_LINE = '\n';

export const isSmsTooLong = (smsContent: string) => smsContent.length >= TWILIO_MAX_LENGTH_FOR_BODY;

export const getSmsBodyLength = (body: string): number => body.length + countOccurrences(body, NEW_LINE);

export const getSmsSegmentsCount = (body: string): number => new SegmentedMessage(body).segmentsCount;

export const normalizePhoneNumberToE164 = (rawPhoneNumber: string): string | undefined => {
  const phoneNumber = parsePhoneNumberFromString(rawPhoneNumber.trim());
  if (isNil(phoneNumber) || !phoneNumber.isValid()) {
    return undefined;
  }
  return phoneNumber.number;
};
